module.exports = __webpack_public_path__ + "img/icon_punched-card1.eb39152e.svg";